import request from '@/utils/request'

export function getPromotionplan(params) {
  return request({
    url: '/marketing_assets/promoted_objects/list_for_compaign',
    method: 'get',
    params
  })
}

export function createAdvertisingPlan(data) {
  return request({
    url: '/ad_management/campaign/store_for_mp',
    method: 'post',
    data
  })
}

export function createAdGroup(data) {
  return request({
    url: '/ad_management/adgroup/store_for_mp',
    method: 'post',
    data
  })
}

export function createAdvertisingIdeas(data) {
  return request({
    url: '/ad_management/adcreative/store_for_mp',
    method: 'post',
    data
  })
}

// 获取省市区
export function getProvincialurbanareas(params) {
  return request({
    url: '/delivery_auxiliary/regions',
    method: 'get',
    params
  })
}

// 获取出价配置
export function getManagement(params) {
  return request({
    url: '/ad_management/get_page_config',
    method: 'get',
    params
  })
}

// 提交创建广告数据
export function createAlldata(data) {
  return request({
    url: '/ad_management/mp_ad_commons',
    method: 'post',
    data
  })
}

// 获取mp数据源
export function getDataSource(params) {
  return request({
    url: '/ad_management/get_tracking_source_list',
    method: 'get',
    params
  })
}

// 获取公共广告详情
export function getbleRule(id) {
  return request({
    url: `/ad_management/mp_ad_commons/${id}`,
    method: 'get'
  })
}

// mp原生页列表（模拟）
export function getNativepage(params) {
  return request({
    url: '/ad_management/get_native_page',
    method: 'get',
    params
  })
}

// 广告主创建广告
export function addAdvertise(params) {
  return request({
    url: '/ad_management/mp_simulations',
    method: 'post',
    params
  })
}
// 修改公共广告
export function editPublicads(id, data) {
  return request({
    url: `/ad_management/mp_ad_commons/${id}`,
    method: 'put',
    data
  })
}
// mp广告详情
export function mpadDetails(id) {
  return request({
    url: `/ad_management/mp_ad_accounts/${id}`,
    method: 'get'
  })
}

// mp修改广告
export function mpeditAd(id, data) {
  return request({
    url: `/ad_management/mp_ad_accounts/${id}`,
    method: 'put',
    data
  })
}

